import { FC, useCallback, memo } from 'react';

import { gettext } from 'medialoopster/Internationalization';
import {
  EightK,
  EightKPlus,
  FourK,
  FourKPlus,
  HD,
  NA,
  Remove,
  SD,
  TwoK,
  TwoKPlus,
  UHD,
} from 'medialoopster/icons';

import { VideoAsset } from '../../../../state/modules/video/types';
import StatusElement from '../StatusElement';

const renderFormatIcon = (format: string) => {
  if (format === '--') return <Remove style={{ fontSize: '1.2rem' }} />;
  if (format === 'HD') return <HD style={{ fontSize: '1.2rem' }} />;
  if (format === 'SD') return <SD style={{ fontSize: '1.2rem' }} />;
  if (format === '2K') return <TwoK style={{ fontSize: '1.2rem' }} />;
  if (format === '2K+') return <TwoKPlus style={{ fontSize: '1.2rem' }} />;
  if (format === '4K') return <FourK style={{ fontSize: '1.2rem' }} />;
  if (format === '4K+') return <FourKPlus style={{ fontSize: '1.2rem' }} />;
  if (format === '8K') return <EightK style={{ fontSize: '1.2rem' }} />;
  if (format === '8K+') return <EightKPlus style={{ fontSize: '1.2rem' }} />;
  if (format === 'UHD') return <UHD style={{ fontSize: '1.2rem' }} />;
  if (format === 'N/A') return <NA style={{ fontSize: '1.2rem' }} />;
  return <></>;
};

const formatTitleMap: Record<string, string> = {
  '--': gettext('Unknown format'),
  HD: 'HD',
  SD: 'SD',
  '2K': '2K',
  '2K+': '2K+',
  '4K': '4K',
  '4K+': '4K+',
  '8K': '8K',
  '8K+': '8K+',
  UHD: 'UHD',
  'N/A': 'N/A',
};

type Props = {
  readonly isWide: boolean;
  readonly asset: VideoAsset;
};

const VideoAssetFormat: FC<Props> = ({ isWide, asset }: Props) => {
  const renderAssetFormatIcon = useCallback(
    () => renderFormatIcon(asset.video_format),
    [asset.video_format],
  );
  return (
    <StatusElement
      renderIcon={renderAssetFormatIcon}
      title={`${gettext('Video format')}: ${formatTitleMap[asset.video_format]}`}
      showLabel={isWide}
      label={
        formatTitleMap[asset.video_format] === formatTitleMap['--']
          ? gettext('Cannot detect video format')
          : `${asset.video_codec} (${asset.video_size})`
      }
    />
  );
};

export default memo(VideoAssetFormat);
